import { render, staticRenderFns } from "./SurveyCheckboxOption.vue?vue&type=template&id=e924fca8"
import script from "./SurveyCheckboxOption.vue?vue&type=script&lang=js"
export * from "./SurveyCheckboxOption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports